module.exports = __webpack_public_path__ + "img/img14.63f07a8f.jpg";